import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DeliveryIndicator } from '../../models/delivery-indicator';
import { DeliverySearch } from '../../models/delivery-search';
import { ApiService } from '../../../../core/services/api.service';
import { DeliveryOperativeDto } from '../../models/delivery-operative-dto';
import { DeliveryOperativeDetailComponent } from './delivery-operative-detail.component';
import { ShipDetailEnum } from '../../../../enums/ship-detail-enum';
import { ShipStatusEnum } from '../../../../enums/ship-status-enum';
import { DataTableComponent } from '../../../../shared/data-table/data-table.component';

@Component({
  selector: 'delivery-operative',
  templateUrl: './delivery-operative.component.html',
  styleUrls: ['./delivery-operative.component.scss']
})

export class DeliveryOperativeComponent implements OnInit, OnDestroy {
  @ViewChild(DeliveryOperativeDetailComponent) asideDetail: DeliveryOperativeDetailComponent;

  @ViewChild("tableChild") tableChild: DataTableComponent<DeliveryOperativeDto>;

  options = {
    columnTitles: ['#', 'DELIVERY_OPERATIVE.TABLE.DELIVERY_DATE', 'DELIVERY_OPERATIVE.TABLE.VEHICLE', 'DELIVERY_OPERATIVE.TABLE.CLIENT',
      'DELIVERY_OPERATIVE.TABLE.MATERIAL',
      'DELIVERY_OPERATIVE.TABLE.STATUS_MATERIAL', 'DELIVERY_OPERATIVE.TABLE.SHIP_STATUS', 'DELIVERY_OPERATIVE.TABLE.ACTIONS'],

    columnReferences: ['id', 'deliveryDate', 'vehicle', 'client', 'product', 
      'statusDetail_ShipDetailEnum', 'status_ShipStatusEnum', 'actions'],

    actionButtons: { detail: true }
  };

  pagePath = 'api/Delivery/getDeliveryOperative';

  displayedColumns = ['id', 'deliveryDate', 'vehicle', 'client', 'product', 'operator', 'autorization', 'statusItem',
    'statusShip', 'actions'];

  search: DeliverySearch;
  data: DeliveryOperativeDto[];
  idShip: number;
  shipDetailEnum = ShipDetailEnum;
  shipStatusEnum = ShipStatusEnum;

  task: any;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.search = new DeliverySearch(new Date(), new Date(), 0, -1, undefined, null);
    this.setIntervalSearch();
  }

  ngOnDestroy(): void {
    this.endIntevalSearch();
  }

  public onSearchEvent(search: DeliverySearch): void {
    this.search = new DeliverySearch(search.initDate, search.endDate, search.vehicle, search.status, search.client, null);
    // this.search = search;
    this.tableChild.firstPage()
    this.loadGrid(search);
  }

  public onClickDetail(element: DeliveryOperativeDto): void {
    this.idShip = element.idShip;
    setTimeout(() => {
      this.asideDetail.open(element.id, element.idShip, element.idItem, element.position, element.idVehicle);
    });
  }
  private loadGrid(search: DeliverySearch): void {
    this.tableChild.loadPage(search);
  }

  private setIntervalSearch() {
    this.task = setInterval(() => {
        this.loadGrid(this.search);
    }, 5 * 60000);
  }

  private endIntevalSearch() {
    if(this.task) {
      clearInterval(this.task);
    }
  }

  public getEnumText(e: ShipDetailEnum): string {
    if (e == ShipDetailEnum.LOADED) {
      return 'Cargado';
    } else if (e == ShipDetailEnum.REJECTED) {
      return 'Rechazado';
    } else if (e == ShipDetailEnum.WAREHOUSE) {
      return 'Almacén';
    }

    return '';
  }

  public getIcon(status: ShipDetailEnum): string {
    if (status == ShipDetailEnum.WAREHOUSE) {
      return 'location_city';
    } else if (status == ShipDetailEnum.LOADED) {
      return 'local_shipping';
    } else if (status = ShipDetailEnum.REJECTED) {
      return 'cancel_presentation';
    }

    return '';
  }

  public getEnumShipStatusText(e: number): string {

    if (e == 0) {
      return 'Cargado';
    } else if (e == 1) {
      return 'En tránsito';
    } else if (e == 2) {
      return 'Llego a destino';
    } else if (e == 3) {
      return 'Cliente ausente';
    } else if (e == 4) {
      return 'Entregado';
    }

    return '';
  }

  public getIconShipStatus(e: number): string {

    if (e == 0) {
      return 'local_shipping';
    } else if (e == 1) {
      return 'local_shipping';
    } else if (e == 2) {
      return 'home';
    } else if (e == 3) {
      return 'voice_over_off';
    } else if (e == 4) {
      return 'how_to_reg';
    }

    return '';
  }

}
